import { Fragment } from "react";
import Footer from "../../../components/Footer/Footer";
import Header from "../../../components/Header/Header";
import HeadSection from "../../../components/meta";
import SignupForm from "./signupForm";

export default function Signup() {
  return (
   <Fragment>
      <HeadSection
        title={"SIGNUP"}
        keywords={""}
        addPostFixTitle={true}
        largeTwitterCard={true}
        showCanonical={true}
        content={
          "Empower yourself with Seed to Tree—your tech blog & academy for mastering AI, software, and IT. Discover expert tutorials and digital solutions to unlock your potential."
        }
        link={`/signup`}
      />
      <Header isActive="signup" />
       <SignupForm />
      <Footer />
    </Fragment>
  );
}
